import { Controller, useFormContext } from 'react-hook-form';

import { WrappedInput } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import type { IForm } from './types';

export function OrderNumberAndCoupon() {
  const { control, watch } = useFormContext<IForm>();
  const { t } = useAppTranslation(['common', 'demand', 'summary']);
  const [modality, loadType] = watch(['modality_id', 'cargo_type_id']);
  if (!modality || !loadType) return null;
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Controller
        control={control}
        rules={{
          maxLength: {
            value: 500,
            message: t('common:msg.max_chars_with_var', { max: 500 }),
          },
        }}
        name="additional_data.order_no"
        render={({ field, fieldState: { error } }) => (
          <WrappedInput
            {...field}
            isOnModal
            id="form-order-number"
            className="col-start-1"
            label={t('summary:titleOrder')}
            value={field.value ?? ''}
            error={error?.message}
            onChange={(e) => {
              const value = e.target.value
                .replace(/[\t\n\r]/g, ' ')
                .replace(/\s+/g, ' ');
              field.onChange(value);
            }}
          />
        )}
      />
      <Controller
        control={control}
        name="additional_data.coupon"
        render={({ field }) => (
          <WrappedInput
            {...field}
            className="hidden"
            isOnModal
            id="form-coupon"
            label={t('summary:titleCoupon')}
            placeholder={t('summary:coupon')}
            value={field.value ?? ''}
          />
        )}
      />
    </div>
  );
}
